export default new Map<string, string>([['10', 'nuove-costruzioni']]);
